var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_766_120",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_766_120",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAE0UlEQVR4nO1dTY8UVRR9iaISxIUfEPxay8CG+APcqCFByYz9bjPIRHcsDDAirkyM7oGBZubdTssk7ifGrRmMC+IO4kZnYEFYOrpQE/lKhgGOuXbHj9Gpqu6urvuq6p7kJp3uma77znn31Huvql47ZzAYDAZDxOhgYgeD3mbQOQYtMugaw/8W4O9KyOvue7QY4Fvyt/I/2nmXGi3QMwz/PsN/xyAMEgF0OYCm5bu021MadEAvBtAsg+4MSvz/hHzXuYADL2i3L1p0cHiT9FYG3cyR+P8IEUCffo53H9Nub1SYQ2MXg5ZGSPw6a/I/tEFj2u2OAnOggwF0uyjy/w5/qw1qujqjDTrC8PeLJ/+vk/QDhj/h6ogA/54W8etjDnTc1c12+u35AbTCoE4ATTEae2Yx/tQneOVhCXkt73U/858x6Kc+7eh+bexITrj9eb6/GED7FkAPZT2G/C2j8QaDvu3nnBBwYKerMlrY+2jW0U4ArQQ0x4c9JqPZYPgfMwrx/QLoEVdVMOjjjORfboOey+u4MhMOoG8yivCRq+oMN8vsNoC+PA3anPfxpWcH+C8yHP92CxPPu6qht7yQ5sOXRkH+v0VIrwRZ0HPVW1hL7v0BtJKn7WwExsS23ogqSYQ7lVrAk3F2eq9rjheYj89QBUddVZC+pOwvFp9T2hDVX3JVwCwmn81w4ttXdF4BzTdTcnpwHpPbXdnRhj+U5v0LfUyy8oIcM8D/nFIFk67s6F1GTKqAjmJu8ym5nXVlR+8ablIFTGnlFuDfSRHgK1d2MOh6ciMbexRzezlFgGuu7AigX5MaeR70pFZuHRx8OkWAX1zZEUCrSY3s4PAmrdxkZpxij6uu7EgbgjrLzwTgiDvI0LAKUIYJoHPJ8Uz3ype/lSYARx9/tkHaMhP1vUS9tfbZALqnTxqNJKRtcq1Ac+SWMJzzX2sTxMUJcSEqEbJd7apcnHUReX5lbYc3jrUobmORnhABGVCK0zHYz3IEREAj5C7rGCpglPfzI+YIoBvRT7SqHk4b2gSwCaBPAlsF6BPBSqHtQGZB2tDugWwVoE8CmwXpE8FKoe1AZkHa0O6BbBWgTwKbBekTwUpRRwtakm1s5DrESUxtkZDX8hCIxspsbQQIoFXZ2iDpVvbu88F0rLuJkwmQK/mM5qtZO0Ub9FpRIjhtFNHINuhIv3n19h4yAXIgYWmQJ2hkDwmGv2IVMLz9TPdL/j+q4AMTYHj7GRtUAEZztwkwpABzoMcHFWAe+7eaAEMKMI/9WwcVoIVDT5gAQ1dAY9egApgFKW8nFkAfWgUMPwpaHnQYGkBXTYB8JkPHRrFBSB7htFFEIwP8XVleyJpTQON1W4oYgQgBNC3WshHx8ll3VdQW40ZYDbTcneE2d8scQaI72vEnilh6qKUFccShzb8JoA3tHshWAfoksFmQPhGsFNoOZBakDe0eyFYB+iSwWZA+EawU2g5kFqQN7R7IVgH6JHCdLUgeVtYmgdXC/x6DBRX2A2wcWUSyVYGfqXEFnNTmX26EHavrdjUdvPWSiwG93/CtW++fcZH9EuoFfVKoqFiMassygSTU27xpLQKCMKJYk54fHfnrzwmyk5SMECqyl9BNaUsAnYpiizKDwWAwGAwGg8Hgyo4/AM/cPNB346qnAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.ee2dc9ee04b11699679b153e298bbe36.svg";
export { ForwardRef as ReactComponent };